"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * NWG.Commerce.Microshop - Api
 * NWG.Commerce.Microshop - Api functionality
 *
 * The version of the OpenAPI document: NWG.Commerce.Microshop - Api
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppContextTransportTypeTypeToJSON = exports.AppContextTransportTypeTypeFromJSONTyped = exports.AppContextTransportTypeTypeFromJSON = exports.AppContextTransportTypeType = void 0;
/**
 *
 * @export
 */
exports.AppContextTransportTypeType = {
    Standard: 0,
    PrePaidFreightOptions: 1,
    ShareShip: 2,
    WillCall: 3
};
function AppContextTransportTypeTypeFromJSON(json) {
    return AppContextTransportTypeTypeFromJSONTyped(json, false);
}
exports.AppContextTransportTypeTypeFromJSON = AppContextTransportTypeTypeFromJSON;
function AppContextTransportTypeTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.AppContextTransportTypeTypeFromJSONTyped = AppContextTransportTypeTypeFromJSONTyped;
function AppContextTransportTypeTypeToJSON(value) {
    return value;
}
exports.AppContextTransportTypeTypeToJSON = AppContextTransportTypeTypeToJSON;
